import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { PcrProtocol } from 'entities/pcr_protocol'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { PcrProtocolViewModel } from 'view_models/pcr_protocol_view_model'

export const pcrProtocolColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: 'PcrProtocol',
        values: [
            {
                name: 'CreateDate',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'pcr_protocol_created_at',
                searchType: { name: 'created_at', type: 'date' },
            },
            {
                name: 'ProbeCount',
                align: 'center',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'pcr_protocol_probe_count',
                searchType: { name: 'probe_count', type: 'number' },
            },
            {
                name: 'SampleCount',
                th: true,
                align: 'center',
                width: 150,
                form: form,
                orderAttr: 'pcr_protocol_sample_count',
                searchType: { name: 'sample_count', type: 'number' },
            },
            {
                name: 'Note',
                th: true,
                minWidth: 300,
                form: form,
                orderAttr: 'pcr_protocol_note',
                searchType: { name: 'note', type: 'text' },
            },
        ],
    }
}

export type PcrProtocolTableDataProps = {
    pcrProtocol?: PcrProtocol
    displaySetting: DisplaySetting
}

export const PcrProtocolTableData = ({ pcrProtocol, displaySetting }: PcrProtocolTableDataProps): JSX.Element => {
    if (!pcrProtocol) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new PcrProtocolViewModel(pcrProtocol)
        return (
            <>
                <TableCell>{vm.createdAtText()}</TableCell>
                <TableCell align="center">{pcrProtocol.probeCount} probes</TableCell>
                <TableCell align="center">{pcrProtocol.sampleCount} samples</TableCell>
                <TableCell>{pcrProtocol.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
